module.exports = __webpack_public_path__ + "static/media/breakfast3.75a3f4d8.png";